import DOMPurify from 'dompurify';

const DEFAULT_CONFIG = {
  ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'p', 'br', 'ul', 'ol', 'li', 'span'],
  ALLOWED_ATTR: [],
};

export function sanitizeText(value) {
  if (value == null) return '';
  const raw = typeof value === 'string' ? value : String(value);
  return DOMPurify.sanitize(raw, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim();
}

export function sanitizeHtml(value) {
  if (value == null) return '';
  const raw = typeof value === 'string' ? value : String(value);
  return DOMPurify.sanitize(raw, DEFAULT_CONFIG);
}

export function sanitizeList(values) {
  if (!Array.isArray(values)) return [];
  return values.map((item) => sanitizeText(item)).filter(Boolean);
}
